export default __webpack_public_path__ + "static/media/chooseus3.faf69afc.png";